import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import IDrugType from '../interfaces/IDrugType';
import Layout from '~/components/Layout';

export default function Create() {     
  const {register, handleSubmit, control, setValue:setFormValue} = useForm<IDrugType>();
  const fields = [
      { name: 'name', type: 'string'},
  ];
  
    return(
      <Layout marginLayout={true}>
        <CrudCreate model={'drug-type'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        messageSuccess={'Drug type successfully created!'}  
        title={'Add drug type'}  
        subheader={'Add drug type'}
        setFormValue={setFormValue} />
      </Layout>
    )
}
